import React from "react";
import useFetchAllData from "Hooks/useFetchAllData";
import { GetAllWeeklyHolidays } from "adminApi/LeaveApi/WeeklyHolidayApi";
import Skeleton from "react-loading-skeleton";

const WeeklyHolidayList = ({ refreshTrigger }) => {
    const { data: holidays, loading, error, refetch } = useFetchAllData(GetAllWeeklyHolidays);

    React.useEffect(() => {
        refetch();
    }, [refreshTrigger]);

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                Error loading holidays: {error.message}
            </div>
        );
    }

    return (
        <div className="row g-2">
            {loading ? (
                Array(7).fill(0).map((_, i) => (
                    <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                        <div className="card border-0 shadow-sm p-2">
                            <Skeleton height={30} width={30} className="mb-1" />
                            <Skeleton height={15} width="50%" />
                        </div>
                    </div>
                ))
            ) : (
                holidays.map((item) => (
                    <div key={item.holiday_id} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                        <div className={`holiday-card ${item.is_holiday ? "is-holiday" : ""}`}>
                            <div className="holiday-icon">
                                <i className={`bi ${item.is_holiday ? "bi-calendar-check-fill" : "bi-calendar"}`}></i>
                            </div>

                            <div className="holiday-content">
                                <h6 className="day-name">{item.day_name}</h6>
                                <div className={`holiday-status ${item.is_holiday ? "active" : "inactive"}`}>
                                    {item.is_holiday ? "Weekly Holiday" : "Working Day"}
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default WeeklyHolidayList;
